import {WidgetEventStruct} from '../../widget-event.struct';
import {CallbackWidgetEnum} from '../../../enums';

export class CallbackWidgetEventStruct extends WidgetEventStruct {
  public event_callback_widget_type: CallbackWidgetEnum;
} // end Package
